// Incoming auth links can contain one-use credentials in query strings or fragments.
export function telemetryUrl(url: string): string {
  const suffixStart = url.search(/[?#]/);
  return suffixStart === -1 ? url : url.slice(0, suffixStart);
}
